<script>
  // import LocalizacaoService from '../../../../domain/policia-civil/localizacao/services/localizacao'
  import AtendentePatioService from '../../../../domain/policia-civil/atendente-patio/services/atendente-patio'
  import GrvService, {uploadFotoGrvIndividual} from '../../../../domain/grv/services/index'
  import {fileToBase64} from '../../../_default/utils/fileToBase64'
  import { isArray, debounce } from 'lodash'
  let templateArquivo = {id: null, nomeArquivo: null, nomeOriginal: null, descricao: null, tipo: null, arquivo: null}

  export default {
    components: {},
    nome: 'localizacao-veiculo',
    data () {
      return {
        isLoading: false,
        isLoaded: false,
        cadastroError: null,
        atualizadoSucesso: null,
        grvDisabled: true,
        grv: [],
        data: {
          id: null,
          numero: null,
          ano: null,
          bairroApreensao: null,
          chassi: null,
          numeroMotor: null,
          chavesVeiculo: 1,
          numeroChave: null,
          cidadeApreensao: null,
          cidadeCondutor: null,
          codigoInfracao: null,
          equipamentos: [],
          motivoInfracaoOutros: null,
          marca: null,
          modelo: null,
          cor: null,
          vaga: null,
          cpfCondutor: null,
          data: null,
          dataApreensao: null,
          enderecoApreensao: null,
          enderecoCondutor: null,
          estadoCondutor: null,
          lacres: [],
          matriculaAgenteApreensor: null,
          nivelCombustivel: null,
          nomeAgenteApreensor: null,
          nomeCondutor: null,
          numeroAutoInfracao: null,
          observacoes: null,
          orgaoEmissorRgCondutor: null,
          placa: null,
          renavam: null,
          rgCondutor: null,
          telefoneCondutor: null,
          tipoOperacao: 2,
          tipoRemocao: 2,
          volumesInteriorVeiculo: null,
          comRubrica: null,
          rubrica: null,
          comAssinaturaCondutor: null,
          assinaturaCondutor: null,
          comAssinaturaTestemunha: null,
          condutorPresente: null,
          ufApreensao: null,
          orgaoApreensor: null,
          reboque: null,
          reboquista: null,
          contrato: null,
          bemCategoria: null,
          patio: null,
          kmForaDaCidade: null,
          kmInicialDoReboque: 0,
          kmFinalDoReboque: 0,
          complementoApreensao: null,
          complementoCondutor: null,
          codigoGrv: null,
          liberarPorDecisaoJudicial: false,
          liberarPorPrensa: false,
          liberarPorRouboFurto: false,
          recebedorPatio: null,
          tipoProcesso: null,
          arquivos: [
            JSON.parse(JSON.stringify(templateArquivo))
          ]
        },
        patio: null,
        atendentes: [],
        listaGrvs: [],
        patios: [],
        filtroInput: {
          id: null,
          titulo: ''
        },
        showOptionsAutocomplete: false,
        loading: false,
        formdataFotosParaUpload: []

      }
    },
    computed: {
      patiosComputed () {
        return this.patios.map((v) => {
          return {label: v.nome, value: v.id}
        })
      },
      grvComputed () {
        return this.listaGrvs.map((v) => {
          let placa = v.tipoProcesso === 1 ? v.placaOriginal : v.placa
          return {label: `${v.numero} - ${placa}`, value: v.id}
        })
      }
    },
    created () {
      this.carregarPatios()
      this.carregarAtendente()
    },
    mounted () {
      this.start()
    },
    activated () {
    },
    destroyed () {
    },
    watch: {},
    methods: {
      carregarGrv () {
        var id = this.data.id
        this.$loaderOverlay.open().message('Carregando Grv')
        GrvService.find(id, false)
        .then((response) => {
          this.data = response.data
          this.data.recebedorPatio = response.data.recebedorPatio ? response.data.recebedorPatio.id : null
          console.log(this.data)
          this.clearInputFiles()
        })
        .then(() => {
          this.$loaderOverlay.hide()
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          console.log(response)
        })
      },
      carregarPatios () {
        AtendentePatioService.patios()
        .then(response => {
          this.patios = response.data.patios
        })
        .catch(error => {
          console.log(error)
          alert('Erro ao carregar a lista de leilões')
        })
      },
      carregarAtendente () {
        this.$loaderOverlay.open().message('Carregando')
        AtendentePatioService.list(200, 1, '&busca=')
        .then((response) => {
          console.log(response.data)
          this.atendentes = response.data.result
          this.isLoaded = true
          this.$loaderOverlay.hide()
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          console.log(response)
        })
      },
      start () {
        this.isLoaded = true
      },
      selectedGrv (e) {
        if (e !== null) {
          this.data.id = e.value
          this.carregarGrv()
        } else {
          this.data.arquivos = []
        }
      },
      adicionarArquivo () {
        this.data.arquivos.push(JSON.parse(JSON.stringify(templateArquivo)))
      },
      uploadFoto: async function (e) {
        for (let file of e.target.files) {
          this.adicionarArquivo()
          const formData = new FormData()
          formData.append('file', file, file.name)
          this.formdataFotosParaUpload.push(formData)

          const data = await fileToBase64(file)
          const lastPosition = this.data.arquivos.length - 1
          this.data.arquivos[lastPosition].nomeArquivo = file.name
          this.data.arquivos[lastPosition].nomeOriginal = file.name
          this.data.arquivos[lastPosition].tipo = 1
          this.data.arquivos[lastPosition].arquivo = data
          this.data.arquivos[lastPosition].fromCelular = true
        }
      },
      openMultipleInputFile (inputRef) {
        this.$refs[inputRef].click()
      },
      excluirFoto (index) {
        this.$delete(this.data.arquivos, index)
      },
      uploadFotoIndividualGrv: async function (grvId) {
        this.$loaderOverlay.message('Cadastrando as fotos, aguarde...')
        let counter = 0
        for (let file of this.data.arquivos) {
          ++counter
          console.log(file)
          this.$loaderOverlay.message(`Cadastrando foto ${counter} de ${(this.data.arquivos || []).length}, aguarde...`)
          try {
            await uploadFotoGrvIndividual(grvId, {data: file.arquivo, filename: 'fotoGrv'})
          } catch (error) {
            console.log('DEU RUIM', error)
          }
        }
        return new Promise(resolve => resolve(console.log('ENVIOU TODAS AS FOTOS!')))
      },
      selectedPatio () {
        if (this.patio) {
          this.filtroInput.titulo = ''
          this.grvDisabled = false
        } else {
          this.grvDisabled = true
        }
      },
      clearInputFiles () {
        if (this.$refs.fileInptImg) this.$refs.fileInptImg.value = ''
        if (this.$refs.fileInptImgCelular) this.$refs.fileInptImgCelular.value = ''
      },
      submit () {
        /* eslint-disable */
        console.log(this.data.arquivos)
        const data = JSON.parse(JSON.stringify(this.data))
        this.cadastroError = null
        this.atualizadoSucesso = false
        if(!confirm('Deseja realmente salvar?')){
          return
        }
        this.$loaderOverlay.open().message('Processando...')
        this.$bar.start()
        window.setTimeout(() => {
          this.$loaderOverlay.message('Aguarde...')
        }, 1000)
        data.arquivos = data.arquivos.filter(file => !file.fromCelular)
        GrvService.atualizacao(data, this.data.id, this.data.tipoProcesso).then((response) => {
          let callbackEnd = () => {
            this.uploadFotoIndividualGrv(response.data.id)
              .then(() => {
                this.formdataFotosParaUpload = []
                this.carregarGrv()
                this.$bar.finish()
                this.$loaderOverlay.hide()
                if (this.$route.params.id) {
                  // Continua na mesma tela de edição
                  // this.$nextTick(() => {
                  this.start()
                  this.atualizadoSucesso = true
                  this.$el.querySelector('#sucessMsg').focus()
                  // })
                } else {
                  alert('GRV cadastrada com sucesso.')
                  // Redirecionar para tela de visualização da grv criada
                  // this.$router.push({name: 'grv.visualizar', params: {id: response.data.id}})
                }
              })
          }
          callbackEnd()
        }).catch((response) => {
          this.$bar.finish()
          this.$loaderOverlay.hide()
          this.cadastroError = response.data.errors
          this.$nextTick(() => {
            this.$refs.error.focus()
          })
          console.log(response)
        })
      },

      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      },
      getListaGrvs: debounce(function (search, loading) {
        this.listaGrvs = []
        this.loading = true
        const filtro = search.split(' - ')[0]
        if (filtro) {
          GrvService.listaSimples(search, this.patio)
            .then(result => {
              this.listaGrvs = result.data
              this.loading = false
            })
            .catch(error => {
              console.log(error)
              alert('Erro ao carregar lista de grvs')
              this.loading = false
            })
        } else {
          this.loading = false
        }
      }, 300),
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Cadastro de Localização de Veículo</h1></div>
          <div class="col-sm-6">
            <!--<router-link :to="{name: 'config.estado-veiculo.list'}"
                         class="pull-right hidden-print" style="clear: left"><strong class="label no-radius bg-info">Voltar</strong>
            </router-link>-->
          </div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div class="panel-body">
            <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
              <div class="m-b-sm font-bold">Erro ao registrar, corrija e tente novamente</div>
              <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
            </div>
            <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
            <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null && atualizadoSucesso" class="alert alert-success">
              <div class="font-bold">{{$route.params.id && 'Atualizado' || 'Cadastrado'}} com sucesso!</div>
            </div>
            <form @submit.prevent="submit" class="bs-example form-horizontal">
              <div class="form-group">
                <label for="patio" class="col-sm-4 control-label">Patio</label>
                <div class="col-sm-4">
                   <select class="form-control"  v-model="patio" @change="selectedPatio" title="Não selecione caso não queira uma filtragem por pátio" required>
                    <option style="font-weight: bold" :value="null">Selecione um patio</option>
                    <option v-for="cat in patiosComputed" :value="cat.value">{{cat.label}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">GRV</label>
                <div class="col-sm-8">
                  <v-select :options="grvComputed" @search="getListaGrvs" placeholder="Selecione uma grv" @input="selectedGrv" :filterable="false" :disabled="grvDisabled"></v-select>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Atendente</label>
                <div class="col-sm-8">
                  <select class="form-control" v-model="data.recebedorPatio" required>
                    <option :value="null" disabled>Selecione</option>
                    <option :value="atendente.id" v-for="atendente in atendentes" :key="atendente.id">{{atendente.nome}}</option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-4 control-label">Vaga</label>
                <div class="col-sm-8">
                  <input id="vaga" v-model="data.vaga" type="text" class="form-control"/>
                </div>
              </div>

              <div class="clearfix"></div>
              <div class="bg-light lter b-b wrapper-md">
                    <div class="row">
                      <div class="col-sm-6 col-xs-12">
                        <h2 class="font-thin h3">
                          Fotos do veículo
                        </h2>
                      </div>
                    </div>
                  </div>

                  <div class="table-responsive">
                    <table class="table table-hover table-bordered table-striped b-t b-light">
                      <thead>
                      <tr>
                        <th>Id</th>
                        <th>Foto</th>
                        <th>Formato foto</th>
                        <td>Excluir</td>
                      </tr>
                      </thead>

                      <tbody>
                      <tr v-for="(arquivo, index) in data.arquivos" v-if="arquivo.tipo === 1">

                        <td scope="row" width="10%" style="max-width: 10%">{{arquivo.id}}</td>
                        <td scope="row" style="position: relative; display: flex; justify-content: center; align-items: center;">
                          <div class="img-preview-placeholder" v-if="!arquivo.id">
                            Esta imagem é apenas um preview. <br> Salve a GRV para obter o link da imagem original
                          </div>
                            <img :src="arquivo.imageInfo && (arquivo.imageInfo.thumb ? arquivo.imageInfo.thumb : arquivo.imageInfo.full)['url'] || arquivo.arquivo || arquivo.thumb || ''" alt="foto-veiculo" class="img-preview" v-if="arquivo.tipo !== 3" loading="lazy">
                            <span v-else>Ver assinatura</span>
                          </a>
                        </td>
                        <td>{{arquivo.nomeOriginal}}</td>
                        <td scope="row">
                          <label class="i-checks m-b-none">
                            <input type="checkbox" v-model="arquivo.apagar" :id="'apagar-arquivo'+index" tabindex="0"
                                   aria-checked="false" aria-invalid="false"><i></i>
                          </label>
                        </td>
                      </tr>
                      <tr v-if="!data.arquivos || data.arquivos.length === 0">
                        <td colspan="4">Nenhum arquivo nesta GRV</td>
                      </tr>
                      </tbody>
                    </table>
                    <br>
                    <div class="wrapper-sm m-t-n m-b">
                      <input type="file" name="files[]" id="fileInptImg" multiple ref="fileInptImg" @change="uploadFoto" v-show="false" accept="image/*">
                      <button @click="openMultipleInputFile('fileInptImg')" type="button" class="btn btn-info btn-md m-l-xs btn-colsultaGrv btnPicDesktop">
                       Adicionar&nbsp;<i class="fa fa-picture-o"></i>
                      </button>
                      <br>
                      <small>* Você pode selecionar mais de uma foto ao mesmo tempo para enviar</small>
                    </div>
                  </div>
              <hr>
              <div class="row wrapper">
                <u-button class="btn m-b-xs w-xs btn-info m-r-xs" type="submit">
                  <span>Salvar</span>
                </u-button>
                <!--<u-button class="btn m-b-xs w-xs m-r-xs btn-default" @click="$router.push({name: 'config.estado-veiculos.list'})">Cancelar</u-button>-->
                <button class="btn btn-danger btn-md m-l-xs btn-colsultaGrv pull-right">Apagar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
  /* Raphael */
  .autocomplete-input {
    position: relative;
  }
  .autocomplete-input input {
    width: 100%;
    height: 100%;
  }
  .autocomplete-input ul {
    position: absolute;
    border: #999 1px solid;
    list-style-type: none;
    width: 100%;
    max-height: 80px;
    overflow: auto;
    background-color: #fff;
    z-index: 99;
  }
  .autocomplete-input ul li {
    padding: 5px;
    cursor: pointer;
  }
  .autocomplete-input ul li:hover {
    background-color: #fff;
    color: #333;
  }
   .img-preview {
    max-height: 183px;
    max-width: 100px;
  }
  .img-preview-placeholder {
    position: absolute;
    opacity: 0;
    height: 100%;
    width: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }
  .img-preview-placeholder:hover {
    opacity: 1;
    background-color: rgba(0, 0, 0, .6)
  }
  /* .btnPicMobile {
    display: none;
  }
  @media screen and (max-width: 768px) {
    .btnPicMobile {
      display: block;
    }
    .btnPicDesktop {
      display: none;
    }
  } */
</style>



// WEBPACK FOOTER //
// LocalizacaoVeiculo.vue?30b36efe